<div class="flows-container">
  <h2 class="page-title">Entradas e Saídas</h2>

  <div class="filter-bar">
    <div class="date-fields">
      <div class="date-field">
        <label for="flows-since">Data inicial</label>
        <p-datepicker inputId="flows-since" dateFormat="dd/mm/yy" [(ngModel)]="since" [readonlyInput]="true"
          placeholder="Selecione a data inicial" />
      </div>

      <div class="date-field">
        <label for="flows-until">Data final</label>
        <p-datepicker inputId="flows-until" dateFormat="dd/mm/yy" [(ngModel)]="until" [readonlyInput]="true"
          placeholder="Selecione a data final" />
      </div>

      <button class="btn-pesquisar" (click)="applyDateFilter()" [disabled]="isLoading">Filtrar</button>
    </div>

    <button class="btn-refresh" (click)="refresh()" [disabled]="isLoading" title="Atualizar">
      <i class="pi pi-refresh"></i>
    </button>
  </div>

  <div *ngIf="errorMessage" class="error-message">{{ errorMessage }}</div>

  <section class="period-overview">
    <article class="flow-panel entry-panel">
      <div class="flow-panel__header">
        <div>
          <h3>Entradas do período</h3>
          <span>{{ since | date: 'dd/MM/yyyy' }} até {{ until | date: 'dd/MM/yyyy' }}</span>
        </div>
        <strong>R$ {{ periodEntriesTotal | number: '1.2-2' }}</strong>
      </div>

      <ng-container *ngTemplateOutlet="stackedBar; context: { segments: periodEntrySegments, total: periodEntriesTotal }"></ng-container>
    </article>

    <article class="flow-panel outflow-panel">
      <div class="flow-panel__header">
        <div>
          <h3>Saídas do período</h3>
          <span>{{ since | date: 'dd/MM/yyyy' }} até {{ until | date: 'dd/MM/yyyy' }}</span>
        </div>
        <strong>R$ {{ periodOutflowsTotal | number: '1.2-2' }}</strong>
      </div>

      <ng-container *ngTemplateOutlet="stackedBar; context: { segments: periodOutflowSegments, total: periodOutflowsTotal }"></ng-container>
    </article>
  </section>

  <p-table [value]="rows" [loading]="isLoading" [paginator]="true" [rows]="15" [rowsPerPageOptions]="[15, 30, 60]">
    <ng-template pTemplate="header">
      <tr>
        <th>Data</th>
        <th>Entradas</th>
        <th>Saídas</th>
        <th>Resultado</th>
      </tr>
    </ng-template>

    <ng-template pTemplate="body" let-row>
      <tr>
        <td class="date-cell">{{ row.date | date: 'dd/MM/yyyy' }}</td>
        <td>
          <div class="cell-flow">
            <div class="cell-flow__total">R$ {{ row.entriesTotal | number: '1.2-2' }}</div>
            <ng-container *ngTemplateOutlet="compactStackedBar; context: { segments: row.entrySegments, total: row.entriesTotal }"></ng-container>
          </div>
        </td>
        <td>
          <div class="cell-flow">
            <div class="cell-flow__total">R$ {{ row.outflowsTotal | number: '1.2-2' }}</div>
            <ng-container *ngTemplateOutlet="compactStackedBar; context: { segments: row.outflowSegments, total: row.outflowsTotal }"></ng-container>
          </div>
        </td>
        <td>
          <strong class="result-value" [class.negative]="row.result < 0" [class.neutral]="row.result === 0">
            R$ {{ row.result | number: '1.2-2' }}
          </strong>
        </td>
      </tr>
    </ng-template>

    <ng-template pTemplate="emptymessage">
      <tr>
        <td colspan="4" class="empty-message">Nenhum dado encontrado.</td>
      </tr>
    </ng-template>
  </p-table>
</div>

<ng-template #stackedBar let-segments="segments" let-total="total">
  <div class="stacked-bar" [class.empty]="!total">
    <div *ngFor="let segment of segments; trackBy: trackSegment" class="stacked-bar__segment"
      [style.width.%]="segment.percentage" [style.background]="segment.color"
      [title]="segment.label + ': R$ ' + (segment.value | number: '1.2-2') + ' / ' + (segment.percentage | number: '1.1-1') + '%'">
    </div>
  </div>

  <div class="segment-list">
    <div *ngFor="let segment of segments; trackBy: trackSegment" class="segment-row">
      <span class="segment-row__marker" [style.background]="segment.color"></span>
      <span class="segment-row__label">{{ segment.label }}</span>
      <strong>R$ {{ segment.value | number: '1.2-2' }}</strong>
      <span>{{ segment.percentage | number: '1.1-1' }}%</span>
    </div>
  </div>
</ng-template>

<ng-template #compactStackedBar let-segments="segments" let-total="total">
  <div class="stacked-bar compact" [class.empty]="!total">
    <div *ngFor="let segment of segments; trackBy: trackSegment" class="stacked-bar__segment"
      [style.width.%]="segment.percentage" [style.background]="segment.color"
      [title]="segment.label + ': R$ ' + (segment.value | number: '1.2-2') + ' / ' + (segment.percentage | number: '1.1-1') + '%'">
    </div>
  </div>

  <div class="compact-list">
    <span *ngFor="let segment of segments; trackBy: trackSegment" [title]="segment.label">
      <i [style.background]="segment.color"></i>
      {{ segment.label }}: R$ {{ segment.value | number: '1.2-2' }} / {{ segment.percentage | number: '1.1-1' }}%
    </span>
  </div>
</ng-template>
